const $ = window.jQuery

import { throttle  } from 'lodash'

const $window = $(window)
const windowResizeHandler = throttle(  function(e) {
  $window.triggerHandler('resize')
}, 400, {
  'leading': true,
  'trailing': true
} )

let $activeModal = null
let $activeModalBody = null
var localCache = {
  data: {},
  remove: function (url) {
      delete localCache.data[url];
  },
  exist: function (url) {
      return localCache.data.hasOwnProperty(url) && localCache.data[url] !== null;
  },
  get: function (url) {
      return localCache.data[url];
  },
  set: function (url, cachedData, callback) {
      localCache.remove(url);
      localCache.data[url] = cachedData;
      if ($.isFunction(callback)) callback(cachedData);
  }
}
const updateModalBody = function(data) {
  const $data = $(data.responseText)
    /*
    * get block inline styles
    */
    // should_load_separate_core_block_asset filter returns false:
    // to avoid core block css injection: link[id^="wp-block-"], style[id^="wp-block-"] 
    // to have a global style that is the same in all pages: style[id="global-styles-inline-css"]
    // const inlineCssSelector = 'style[id="core-block-supports-inline-css"]' // conflicts between modale and main page!
    const inlineCssSelector = ''
    const $blockStyles = $data.filter(inlineCssSelector)
    let blockStylesHtml = ''
    for(var i = 0; i < $blockStyles.length; i++) {
      blockStylesHtml = blockStylesHtml + $blockStyles[i].outerHTML
    }

    /*
    * get modal markup
    */
    const $modalBody = $data.find('.wp-block-group > .entry-content')
    $activeModalBody.html( blockStylesHtml +  $modalBody.html() );

    /*
    * Getwid counter starts on window scroll (waypoints)
    * not working on modal scroll; as a fix, in modal, set counter to its final value or trigger the counter immediatelly
    */
    // https://wordpress.org/support/topic/initialise-getwid-blocks-after-appending-post-to-document/
    // Getwid Blocks initialization!
    document.body.dispatchEvent(new Event('post-load') ) // same as $(document.body).trigger('post-load')
}
const fetchModalBody = function(event) {
  const button = event.relatedTarget
  // Extract info from data-bs-* attributes
  $activeModal = $(button.getAttribute('data-bs-target'))
  $activeModalBody = $activeModal.find('.modal-body')

  const recipient = button.getAttribute('data-bs-modalfetch') || button.getAttribute('href')
  const iframeSrc = button.getAttribute('data-bs-modaliframe')

  if (iframeSrc) {
    const iframeHtml = `<div class="ratio ratio-16x9"><iframe src="${iframeSrc} "allowfullscreen  webkitallowfullscreen  mozallowfullscreen ></iframe></div>`
    $activeModalBody.html(iframeHtml);
  } else if (recipient) {
    // Update the modal's content.
    $activeModalBody.html('<div class="text-center">Loading...</div>');
    $.ajax( {
      cache: true,
      method: "GET",
      dataType: 'html',
      url: recipient,
      beforeSend: function () {
        if (localCache.exist(recipient)) {
          updateModalBody(localCache.get(recipient))
          return false;
        }
        return true;
      },
      complete: function (jqXHR, textStatus) {
          localCache.set(recipient, jqXHR, updateModalBody);
      }
    })
  }

  /*
  * Dirty way to trigger waypoint refresh (used bu Getwid blocks)
  * http://imakewebthings.com/waypoints/api/context-option/
  * 
  * A cleaner approach coud be reinit Waypoints
  */
  $activeModal.on('scroll', windowResizeHandler)
  $activeModal = $activeModal
}

// reset model content, to remove iframe embed
const resetModalBody = function(event) {
  if ($activeModal) {
    const $activeModalBody = $activeModal.find('.modal-body')
    $activeModalBody.html('<div class="text-center">...</div>');
    $activeModal.off('scroll', windowResizeHandler)
    $activeModal = null
  }
}

const init = function( preload_selector = '[data-bs-toggle="modal"]' ) {
  //https://getbootstrap.com/docs/5.3/components/modal/ 
  //https://getbootstrap.com/docs/5.3/components/modal/#varying-modal-content 
  const modelFetch = document.querySelectorAll('.modal-fetch')
  if (modelFetch) {
    modelFetch.forEach(element => {
      element.addEventListener('show.bs.modal', fetchModalBody);
      element.addEventListener('hidden.bs.modal', resetModalBody);
    });
  }

  /*
  * Prefetch modal contents
  */
  $(preload_selector).each(function(index, item){
    const recipient = item.getAttribute('data-bs-modalfetch') || item.getAttribute('href')
    if (recipient) {
      $.ajax( {
        cache: true,
        method: "GET",
        dataType: 'html',
        url: recipient,
        beforeSend: function () {
          if (localCache.exist(recipient)) {
            return false;
          }
          return true;
        },
        complete: function (jqXHR, textStatus) {
          localCache.set(recipient, jqXHR);
        }
      })
    }
  })
}

const destroy = function() {
}

export default {init, destroy}